module.exports = __webpack_public_path__ + "img/gobernanza_confondo.88be1471.png";